// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EqRs_fBWLwalyafLCZ6w{grid-template-columns:268px 1fr;min-height:378px;display:grid}.ytU14hp98QQQzubozuCV{padding:0 24px 18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `EqRs_fBWLwalyafLCZ6w`,
	"alerts": `ytU14hp98QQQzubozuCV`
};
export default ___CSS_LOADER_EXPORT___;
